import { Serie } from "./types/Serie";

export default function createSerieDraftData({ name, description, publisher }) {
	return Serie.partial().parse({
		name,
		description,
		publisher,
	});
}
